import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import filtering from "../utility/filtering";
import {Biscuit} from "../../../../utils";

const useCheckinTimesSidebar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch();
  const store = useSelector(data => data.checkInTimes);

  const [currentCity, setCurrentCity] = useState(
    store.filterPeriodsReducer.length > 0 ?
    store.filterPeriodsReducer[0].location_id :
    ""
  );

  const [currentPrice, setCurrentPrice] = useState(
      store.filterPeriodsReducer.length > 0 ?
          store.filterPeriodsReducer[0].pricetariff_id :
          ""
  );
  const [period, setPeriod] = useState("");
  const [date, setDate] = useState({
    from: null,
    to: null,
    day: "ALL"
  });
  const clickHandler = () => {
    if (currentCity || currentPrice) {
      setIsOpen(!isOpen)
    }  else {
      alert("Please Pick location first")
    }
  }
  useMemo(() => {
    if (store.periods.length > 0) {
      dispatch({
        type: "FILTER",
        source: date.day,
        result: store
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPrice, currentCity, store.periods]);

  useMemo(() => {
    filtering(date, store, dispatch);
    // eslint-disable-next-line
  }, [date, store.periods]);

  const handleClick = val => {
    dispatch({ type: "FILTER", source: val, result: store });
    setDate({ ...date, day: val });
  };

  const handleChangeFrom = value => {
    if (new Date(value).getFullYear() <= 1970) {
      setDate({
        ...date,
        from: null
      });
      return;
    }
    setDate({
      ...date,
      from: new Date(value)
    });
  };

  const handleChangeTo = value => {
    if (new Date(value).getFullYear() <= 1970) {
      setDate({
        ...date,
        to: null
      });
      return;
    }
    setDate({
      ...date,
      to: new Date(value)
    });
  };

  /**
   * Filter openingTimes by their type via redux store
   * @param {String} val 
   */
  const handlePeriod = val => {

    if (val === "no Check-In/No Booking") {
      dispatch({
        type: "FILTER",
        source: "NO_CHECK_IN",
        from: val.toLowerCase(),
        result: store,
        date_start: date.from,
        date_end: date.to
      });

      setPeriod(val);

      return;
    }

    dispatch({
      type: "FILTER",
      source: "PERIOD",
      from: val.toLowerCase(),
      result: store,
      date_start: date.from,
      date_end: date.to
    });

    setPeriod(val);
  };

  return {
    handleChangeFrom,
    handleChangeTo,
    handleClick,
    setCurrentCity,
    date,
    currentCity,
    store,
    handlePeriod,
    period,
    isOpen,
    setIsOpen,
    clickHandler,
    setCurrentPrice,
    currentPrice
  };
};

export default useCheckinTimesSidebar;
